export default __webpack_public_path__ + "7e154927bb680b06d71be6a759eb3f50.png";